export default "__VITE_ASSET__7069a04c__"